"use client";

import { Hamburger } from "../components/utility/hamburger/Hamburger";
import { motion, useInView } from "framer-motion";
import { useEffect, useRef, useState } from "react";
import HamburgerMenuWindow from "../components/utility/hamburger/Hamburger_Win";
import { useLocation } from "react-router-dom";

const Navbar: React.FC = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const [isOpen, setIsOpen] = useState(true);
  const hamburgerClick = () => {
    setIsOpen(!isOpen);
  };

  const [isActive, setIsActive] = useState<number>(() => {
    try {
      const savedIndex = localStorage.getItem("activeMenuIndex");
      return savedIndex ? parseInt(savedIndex, 10) : 0;
    } catch (error) {
      console.error("Error accessing localStorage:", error);
      return 0;
    }
  });

  useEffect(() => {
    setIsActive(isActive);
  }, []);

  useEffect(() => {
    try {
      localStorage.setItem("activeMenuIndex", isActive.toString());
    } catch (error) {
      console.error("Error saving to localStorage:", error);
    }
  }, [isActive]);

 

  // Ref for vector image
  const vectorRef = useRef(null);
  const vectorInView = useInView(vectorRef, { once: true });

  // Animations
  const logoVariants = {
    hidden: { scale: 0.8, opacity: 0 },
    visible: { scale: 1, opacity: 1, transition: { duration: 0.5 } },
  };

  const hamburgerVariants = {
    hidden: { opacity: 0, x: -20 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.5 } },
  };

  const vectorVariants = {
    hidden: { opacity: 0, x: -50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.5 } },
  };

  return (
    <div className="relative w-full h-0 m-auto">
      {/* Vector Image */}
      <motion.img
        ref={vectorRef}
        initial="hidden"
        animate={vectorInView ? "visible" : "hidden"}
        variants={vectorVariants}
        src="/Vector.png"
        alt="vector"
        className="w-[50%] h-auto absolute left-0 z-10 hidden lg:block"
      />

      {/* Hamburger Icon */}
      <motion.div
        initial="hidden"
        animate="visible"
        variants={hamburgerVariants}
        className="fixed left-0 top-3 md:top-14 bg-[#F8D835] pl-[10px] sm:pl-[30px] 2xl:pl-[60px] pr-[15px] sm:pr-[25px] py-[5px] sm:py-[10px] rounded-r-full z-50"
      >
        <Hamburger onClick={hamburgerClick} />
      </motion.div>

      {/* Logo */}
      <div className="w-full flex justify-end lg:justify-start gap-5 items-center pt-[10px] sm:pt-[20px] md:pt-[35px] absolute left-0">
        <motion.a
          href="/"
          initial="hidden"
          animate="visible"
          variants={logoVariants}
          className="w-[100px] sm:w-[140px] xl:w-[178px] xl:h-[99px] 2xl:w-[301px] 2xl:h-[142px] ml-20 z-20 transition-all duration-100"
        >
          {currentPath.includes("/exploration") ? (
            <img
              src="/logo_mineralex_sl.png"
              alt="logo_mineralex_sl"
              className="w-auto h-auto cursor-pointer"
            />
          ) : (
            <img
              src="/logo.png"
              alt="logo"
              className="w-auto h-auto cursor-pointer"
            />
          )}
        </motion.a>
      </div>

      {/* Menu Window */}
      <HamburgerMenuWindow hidden={isOpen} />
    </div>
  );
};

export default Navbar;
